import MainFiltersBQ from "../../../../../Global/Models/Filters/MainFiltersBQ";

export default class PersonalityQuizParticipationsFilters extends MainFiltersBQ {
  personalityQuizIds?: string[] = null;

  constructor(filters: any) {
    super(filters);
    this.personalityQuizIds = filters?.personalityQuizIds || null;
  }

  public constructMainFiltersUrl?() {
    let url = super.constructMainFiltersUrl();

    if (this.personalityQuizIds && this.personalityQuizIds.length > 0) {
      url += `&personality_quiz_ids=${this.personalityQuizIds.join(",")}`;
    }

    return url;
  }
}
